import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TestConfig {
  showLoadUserError: boolean;
  showInviteUserError: boolean;
  showEditUserError: boolean;
  showDeleteUserError: boolean;
  showSaveComplianceSettingError: boolean;
  showNoParticipantView: boolean;
  showNoCompliantParticipantView: boolean;
  showNoNonCompliantParticipantView: boolean;
}

const initialState: TestConfig = {
  showLoadUserError: false,
  showInviteUserError: false,
  showEditUserError: false,
  showDeleteUserError: false,
  showSaveComplianceSettingError: false,
  showNoParticipantView: false,
  showNoCompliantParticipantView: false,
  showNoNonCompliantParticipantView: false,
};

const testConfigSlice = createSlice({
  name: "testConfig",
  initialState,
  reducers: {
    setShowLoadUserError: (state, action: PayloadAction<boolean>) => {
      state.showLoadUserError = action.payload;
    },
    setShowInviteUserError: (state, action: PayloadAction<boolean>) => {
      state.showInviteUserError = action.payload;
    },
    setShowEditUserError: (state, action: PayloadAction<boolean>) => {
      state.showEditUserError = action.payload;
    },
    setShowDeleteUserError: (state, action: PayloadAction<boolean>) => {
      state.showDeleteUserError = action.payload;
    },
    setShowSaveComplianceSettingError: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.showSaveComplianceSettingError = action.payload;
    },
    setShowNoParticipantView: (state, action: PayloadAction<boolean>) => {
      state.showNoParticipantView = action.payload;
    },
    setShowNoCompliantParticipantView: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.showNoCompliantParticipantView = action.payload;
    },
    setShowNoNonCompliantParticipantView: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.showNoNonCompliantParticipantView = action.payload;
    },
  },
});

export const {
  setShowLoadUserError,
  setShowInviteUserError,
  setShowEditUserError,
  setShowDeleteUserError,
  setShowSaveComplianceSettingError,
  setShowNoParticipantView,
  setShowNoCompliantParticipantView,
  setShowNoNonCompliantParticipantView,
} = testConfigSlice.actions;
export default testConfigSlice.reducer;
